export const reducer = (state, action) => {
  switch (action.type) {
    case 'update_notifications_criteria':
      return {
        ...state,
        notificationCriteria: action.notificationCriteria,
      }
    case 'update_notification_events':
      return {
        ...state,
        notificationEvents: action.notificationEvents,
      }
    case 'update_all':
      return {
        ...state,
        notificationCriteria: {
          ...state.notificationCriteria,
          ...action.notificationCriteria,
        },
        notificationEvents: action.notificationEvents,
      }
    default:
      return state
  }
}

const constructInitialCriteriaValueStates = () => {
  const returnObject = {}
  returnObject['vendorIds'] = null
  returnObject['timezone'] = null
  return returnObject
}

const constructInitialEventValueStates = () => {
  const returnObject = {}
  returnObject['eventTypes'] = []
  return returnObject
}

export const initialState = {
  notificationCriteria: constructInitialCriteriaValueStates(),
  notificationEvents: constructInitialEventValueStates(),
}
